import { Alert, Stack, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

type StPoolSettleConfirmContentProps = {
  /** The action's own confirmation question. */
  message: string;
  /** What this action does to the active cycle, worded per action. */
  settleNote: string;
};

/**
 * Confirmation body for actions that force-settle a pool cycle — disabling a
 * pool, deleting a room that has one. Settlement makes every positive
 * `finalReward` claimable and pushes those users a "reward claimable"
 * notification, which Admin cannot recall afterwards, so ops see it before
 * confirming rather than after.
 */
export function StPoolSettleConfirmContent({ message, settleNote }: StPoolSettleConfirmContentProps) {
  const t = useTranslate();

  return (
    <Stack spacing={1.5}>
      <Typography variant="body2">{message}</Typography>
      <Alert severity="warning">
        {settleNote} {t('module.socialTrading.poolClaimNotifyWarning')}
      </Alert>
    </Stack>
  );
}
